import type { FaireProductEntity } from "../../entity_types/product";

export const p_bp2w76bngn: FaireProductEntity = {
  token: "p_bp2w76bngn",
  type: "product",
  name: "Marinara alla Pappy Pasta Sauce",
  brandToken: "b_3nxmfbpynu",
  brandName: "Ciao Pappy",
  imageUrl:
    "https://cdn.faire.com/fastly/d825a3a03d5708a947db9f0d9574121c4938bbcd8a85fe2b9975628ed44d98c2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a49627f3a781e65bc38b934ded7f959fd1728ac892c1a583735ae0385e2172e4.jpeg",
    "https://cdn.faire.com/fastly/fb8d148ea1f348090108e00fac3780fa2ee50ecff3bc213148984a85996c528d.png",
    "https://cdn.faire.com/fastly/b53012b742e89e01679126fa2a05eb03e3b48cf0dff66f4ca022e0ff668aeb18.jpeg",
    "https://cdn.faire.com/fastly/4a9ff955c4f0cc33ff0c920d72852ccd016b76aa50db17bb25f059a68ec42185.jpeg",
    "https://cdn.faire.com/fastly/c44a7a6331cf558bf53976bea5489bc33947429ab876a2f5fa5d152582d1e549.jpeg",
    "https://cdn.faire.com/fastly/8c829d1ef138e84ae4a125371f3a8ccb0e034f4e2c9e5f2a0498b0ed68b4dfbf.png",
    "https://cdn.faire.com/fastly/4bb75be9d552da696d33c18f4a059b43ec42686dd57cfaefb2bc57fc837f98aa.png",
    "https://cdn.faire.com/fastly/acbfb10816a5bcf00e1d7f9ac4d855e2451c48e4bc2cb02062d2185b2efa3931.png",
    "https://cdn.faire.com/fastly/f9b7c7f71c90f73772bfed1aaf36a6db7eb22e0b72797af3e02e2a788be215fa.png",
  ],
  priceDollars: 8,
  description:
    "Experience the nostalgia of home-cooked meals with Alla Pappy Family Recipe Marinara Sauce. Crafted with love and passed down through generations, it's a flavorful blend of tradition and taste. Create cherished moments with every spoonful.\n\nThis sauce is a full-flavored, fully-seasoned marinara, so you don't need to do a thing. A unique blend of crushed tomatoes, onions, Italian herbs, crushed pepper, extra virgin olive oil, and a touch of sour cream. \n\nThis better-for-you, gluten free, non-GMO pasta sauce is perfect for spaghetti dinners, pizza, lasagna, chicken parmesan, or original recipes. Simple ingredients and low sugar make this authentic marinara sauce the ideal complement to any pasta dish.\n\n100% California tomatoes and non-GMO verified with no added sugar.\n\nBring this deliciousness to any summer BBQ or picnic!",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:54.875Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
